import type { PropsWithChildren } from 'react';

import { CardContent } from './components/CardContent'
import { CardFooter } from './components/CardFooter'
import { CardHeader } from './components/CardHeader'
import { CardMeta } from './components/CardMeta'
import { type ICardStyledProps } from './styles/CardStyled'
import { FlatBorderCardStyled } from './styles/FlatBorderCardStyled'

export interface IFlatBorderCardProps extends ICardStyledProps {}

export const FlatBorderCard = ({
  children,
  ...cardProps
}: PropsWithChildren<IFlatBorderCardProps>) => {
  return <FlatBorderCardStyled {...cardProps}>{children}</FlatBorderCardStyled>
}
FlatBorderCard.Content = CardContent
FlatBorderCard.Footer = CardFooter
FlatBorderCard.Header = CardHeader
FlatBorderCard.Meta = CardMeta

FlatBorderCard.displayName = 'FlatBorderCard'
